import { AlenDevice } from "src/interfaces/IAlenDevice";
import { Device, DeviceType } from "src/interfaces/IDevice";
import { AlenProperty, Property } from "src/interfaces/IProperty";
import { AlenRoom, DEFAULT_FLOOR_NAME, Floor } from "src/interfaces/IZone";
import { DeviceGroup } from "src/pages/FleetManagement/pages/ViewProgram/AlenScheduling/types";
import alenProductConfig, { AlenProductConfigType } from "./alenDeviceConfig";

export const mapAlenPropertyToWyndProperty = (alenProperty: AlenProperty) => ({
  property_name: alenProperty.name,
  property_address: alenProperty.geo_name,
  alen_id: alenProperty.home_id,
  property_id: -1,
});

export const mergeAlenProperties = (
  wyndProperties: Property[],
  alenProperties: Property[]
) => {
  const mergedData = [...wyndProperties];

  alenProperties.forEach((p) => {
    const existingIndex = mergedData.findIndex(
      (e) => e.property_name === p.property_name
    );
    if (existingIndex !== -1) {
      mergedData[existingIndex] = {
        ...mergedData[existingIndex],
        alen_id: p.alen_id,
      };
    } else {
      mergedData.push(p);
    }
  });
  return mergedData;
};

export const mapAlenRoomsToWyndFloors = (alenRoom: AlenRoom): Floor => ({
  name: alenRoom.name,
  alenId: alenRoom.room_id,
});

export const mergeAlenFloors = (wyndFloors: Floor[], alenFloors: Floor[]) => {
  const mergedData = [...wyndFloors];

  alenFloors.forEach((f) => {
    const existing = mergedData.find((e) => e.name === f.name);
    if (existing) {
      existing.alenId = f.alenId;
    } else {
      mergedData.push(f);
    }
  });
  return mergedData;
};

export const mapAlenDeviceToWyndDevice = (alenDevice: AlenDevice): Device => ({
  device_id: alenDevice.id,
  property_id: -1,
  property: { name: "" },
  zone_id: -1,
  zone: { name: alenDevice.name, floor: DEFAULT_FLOOR_NAME },
  device_type: DeviceType.ALEN,
});

export const WRITABLE_PRODUCT_TYPES = [
  "BreatheSmart_75i",
  "BreatheSmart_45i",
  "BreatheSmart_35i",
];

export type AlenProductType = {
  [productId: string]: string;
};

export const mapAlenProductsToTypes = (
  productConfig: AlenProductConfigType
) => {
  const productsType: AlenProductType = {};
  Object.entries(productConfig.products).forEach(([productType, products]) => {
    products.forEach((product) => {
      productsType[product.productInfo.pid] = productType;
    });
  });
  return productsType;
};

export const ALEN_PRODUCT_TYPE_MAP = mapAlenProductsToTypes(alenProductConfig);

export function groupDevicesByProductType(
  devices: AlenDevice[]
): DeviceGroup[] {
  const deviceGroupsMap = new Map<string, DeviceGroup>();

  devices.forEach((device) => {
    const productType = ALEN_PRODUCT_TYPE_MAP[device.product_id];
    if (!deviceGroupsMap.has(productType)) {
      deviceGroupsMap.set(productType, {
        deviceGroupName: productType,
        deviceDetails: [
          {
            productId: device.product_id,
            deviceIds: [device.id],
          },
        ],
      });
    } else {
      const deviceGroup = deviceGroupsMap.get(productType)!;
      const productDetail = deviceGroup.deviceDetails.find(
        (detail) => detail.productId === device.product_id
      );

      if (productDetail) {
        productDetail.deviceIds.push(device.id);
      } else {
        deviceGroup.deviceDetails.push({
          productId: device.product_id,
          deviceIds: [device.id],
        });
      }
    }
  });

  return Array.from(deviceGroupsMap.values());
}
